import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

const CookieHandler = () => {
  const [visitorId, setVisitorId] = useState("");
  const [visitorData, setVisitorData] = useState([]);

  useEffect(() => {
    // Check if a visitor cookie exists
    let storedVisitorId = Cookies.get("visitor_id");

    if (!storedVisitorId) {
      // Create a unique visitor ID
      storedVisitorId = `user_${Date.now()}`;
      Cookies.set("visitor_id", storedVisitorId, { expires: 30 }); // Store for 30 days

      // Save visitor data with timestamp
      const newVisitor = {
        id: storedVisitorId,
        visitTime: new Date().toLocaleString(),
      };

      // Retrieve existing visitors from local storage
      const existingVisitors = JSON.parse(localStorage.getItem("visitors")) || [];

      // Add the new visitor to the array
      const updatedVisitors = [...existingVisitors, newVisitor];

      // Store updated list in local storage
      localStorage.setItem("visitors", JSON.stringify(updatedVisitors));
    }

    // Set visitor ID in state
    setVisitorId(storedVisitorId);

    // Load visitor data from local storage
    const visitors = JSON.parse(localStorage.getItem("visitors")) || [];
    setVisitorData(visitors);
  }, []);

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h2 className="text-xl font-bold text-center mb-4">Website Visitor Tracking</h2>

      {/* Display current visitor ID */}
      <div className="mb-4">
        <h3 className="font-semibold">Current Visitor ID: {visitorId}</h3>
      </div>

      {/* Table for Visitor Data */}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
          <thead className="bg-blue-600 text-white">
            <tr>
              <th className="py-3 px-6 text-left">Visitor ID</th>
              <th className="py-3 px-6 text-left">Visit Time</th>
            </tr>
          </thead>
          <tbody>
            {visitorData.length > 0 ? (
              visitorData.map((visitor, index) => (
                <tr key={index} className="border-b hover:bg-gray-100">
                  <td className="py-3 px-6">{visitor.id}</td>
                  <td className="py-3 px-6">{visitor.visitTime}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="2" className="py-3 px-6 text-center text-gray-500">
                  No visitor data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CookieHandler;
